import {
    Box,
    Card,
    CardContent,
    Container,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../component/Header/Header";
import PortalNavbar from "../../../component/PortalNavbar/PortalNavbar";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function OnlineTutorial() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.onlineTutorial")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main Box className="main">
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: "bold" }}
                        align="center"
                        component="h1"
                    >
                        {t("common.portal.uatNotice")}
                        <br />
                    </Typography>
                    <Card
                        className={matches ? classes.root : classes.rootMobile}
                    >
                        <CardContent>
                            <iframe
                                width="100%"
                                height="315"
                                src=""
                                title="Video for Online Tutorial of eFormSS"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                aria-label="Video for Online Tutorial of eFormSS"
                            ></iframe>
                        </CardContent>
                    </Card>
                </main>
            </Box>
        </Container>
    );
}
export default OnlineTutorial;
